let runtimeUniqueIdCounter = 0;

export const getRuntimeUniqueId = (): number => {
  return runtimeUniqueIdCounter++;
};
